import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const MepsBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string(),
        bankCode: z.string(),
        branchCode: z.string(),
        swiftCode: z.string().optional(),
    }),
);

export class MepsBankAccountPayload extends BankAccountPayload {
    accountNumber: string;
    bankCode: string;
    branchCode: string;
    swiftCode?: string;
}
